import { create } from "zustand";

const useModalStore = create((set) => ({
  contentIsLazyLoading: false,
  setContentIsLazyLoading: (newContentIsLazyLoading) =>
    set({ contentIsLazyLoading: newContentIsLazyLoading }),
  longLazyLoad: false,
  setLongLazyLoad: (newLongLazyLoad) => set({ longLazyLoad: newLongLazyLoad }),
  preventClose: false,
  setPreventClose: (preventClose) => set({ preventClose }),
  transitionType: null,
  setTransitionType: (transitionType) => set({ transitionType }),
}));

const useContentIsLazyLoading = () => {
  const contentIsLazyLoading = useModalStore((s) => s.contentIsLazyLoading);

  return contentIsLazyLoading;
};

const useLongLazyLoad = () => {
  const longLazyLoad = useModalStore((s) => s.longLazyLoad);

  return longLazyLoad;
};

export { useContentIsLazyLoading, useLongLazyLoad };
export default useModalStore;
